import store from '../store'

function showLogin(show = true) {
  try {
    store.commit('setShowLogin', show)
  } catch (error) {
    console.log('登录失败', error)
  }
}
export default {
  install: (Vue) => {
    Vue.prototype.$showLogin = showLogin
  },
  inject: (Store) => {
    Store.prototype.$showLogin = showLogin
  }
}
